import {
  UPDATE_EXPERIMENT_INFO,
  CLEAR_SWEEP_INFO,
  UPDATE_SWEEP_CREATE_STATUS,
  UPDATE_ADD_LOADING,
  UPDATE_LOADING_FORM_TYPE,
  UPDATE_STATE_INFO
} from './actionTypes'

const defaultState = {
  experimentInfo: {
    experiments: [],
    id: "",
    sweepName: "",
    verificationName: "",
    forSim: [],
    tableColumns: [],
    hasSchematic: false,
    baseInterface: {}
  },
  sweepMeasurementInfo: null,
  addLoading: false
}

export const SweepReducer = (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_EXPERIMENT_INFO:
      return {
        ...state,
        experimentInfo: action.currentType === 'all' ? {
          ...state.experimentInfo,
          ...action.info
        } : {
          ...state.experimentInfo,
          [action.currentType]: action.info
        }
      }
    case UPDATE_SWEEP_CREATE_STATUS:
      return {
        ...state,
        sweepCreateStatus: action.status
      }
    case UPDATE_ADD_LOADING:
      return {
        ...state,
        addLoading: action.loading
      }
    case UPDATE_STATE_INFO:
      return {
        ...state,
        [action.currentType]: action.info
      }
    case CLEAR_SWEEP_INFO:
      return {
        ...defaultState
      }
    default: return state
  }
}